<template>
  <DataTable :value="[{}, {}, {}, {}, {}]">
    <Column>
      <template #header>
        <Skeleton width="100%" height="27px" class="p-m-1" />
      </template>
      <template #body>
        <Skeleton width="100%" height="20px" class="p-m-1" />
      </template>
    </Column>
  </DataTable>
</template>

<script>
export default {
  name: 'AppSkeletonTable',
};
</script>

<style>
</style>